export default __webpack_public_path__ + "static/media/undraw_Travelers_re_y25a.fa33c5a5.svg";